@let currencySettings = currencySettingsSignal();

@if (sortedBookedProducts(); as sortedBookedProducts) {
  @if (!!sortedBookedProducts.length && currencySettings) {
    <div class="basket h-full flex flex-column justify-content-between">
      <div class="flex flex-column">
        <ul class="list-none m-l-0">
          @for (bookedProduct of sortedBookedProducts; track bookedProductIndex; let bookedProductIndex = $index) {
            <li class="m-y-6">
              @if (bookedProduct.productType === ProductType.Package) {
                @if (bookedProduct; as bookedPackage) {
                  <div class="baskete-package bg-white">
                    <h5 class="text-base font-semibold p-6">
                      {{ bookedPackage.productTypeName | translate }}
                    </h5>

                    <ul class="basket-package__products list-none p-0 m-l-0">
                      @for (
                        bookedPackageProduct of bookedPackage.productTypes;
                        track packageProductIndex;
                        let packageProductIndex = $index
                      ) {
                        @if (bookedPackageProduct.productType === ProductType.Tariff) {
                          <li>
                            <ng-container
                              *ngTemplateOutlet="
                                bookedTariffTypeTemplate;
                                context: {
                                  bookedTariffType: bookedPackageProduct,
                                  isInPackage: true,
                                  packageProductIndex
                                }
                              "
                            />
                          </li>
                        }
                      }
                    </ul>

                    @if (
                      allBookedPackagePricesGroupedByPackageIndex();
                      as allBookedPackagePricesGroupedByPackageIndex
                    ) {
                      @if (
                        allBookedPackagePricesGroupedByPackageIndex[bookedPackage.packageIndex];
                        as bookedPackagePrice
                      ) {
                        @if (
                          bookedPackagePrice.hasPromoCodeDiscount &&
                          bookedPackagePrice.totalPrice !== bookedPackagePrice.totalDiscountedPrice
                        ) {
                          <div class="flex justify-content-end gap-2 p-6">
                            <span class="basket-promo-code-price text-sm font-semibold line-through">
                              {{ bookedPackagePrice?.totalPrice || 0 | formatPrice: currencySettings }}
                            </span>

                            <span class="basket-promo-code-discounted-price text-base font-semibold">
                              {{ bookedPackagePrice?.totalDiscountedPrice || 0 | formatPrice: currencySettings }}
                            </span>
                          </div>
                        } @else {
                          <span class="flex justify-content-end text-base font-semibold p-6">
                            {{ bookedPackagePrice?.totalPrice || 0 | formatPrice: currencySettings }}
                          </span>
                        }
                      }
                    }
                  </div>
                }
              } @else if (bookedProduct.productType === ProductType.Tariff) {
                <ng-container
                  *ngTemplateOutlet="
                    bookedTariffTypeTemplate;
                    context: { bookedTariffType: bookedProduct, isInPackage: false }
                  "
                />
              }
            </li>
          }
        </ul>

        <div class="flex justify-content-between p-x-6 p-b-6">
          <span class="text-base font-semibold" data-translation="confirmation.total">
            {{ 'confirmation.total' | translate | hideTranslation }}:
          </span>

          <span class="text-base font-semibold">
            {{
              (bookedProductsTotalPriceState()?.isPromoCodeDiscountApplied
                ? bookedProductsTotalPriceState()?.totalDiscountedPrice
                : bookedProductsTotalPriceState()?.totalPrice
              ) | formatPrice: currencySettings
            }}
          </span>
        </div>
      </div>

      @if (selectedStepName() !== 'invoice') {
        <div class="basket-buttons-container border-top-1 bg-white p-x-6 p-y-9">
          <ls-button
            data-nested-translation="basket.checkout"
            [disabled]="isNextButtonDisabled()"
            [styleClass]="'button-primary'"
            [color]="'primary'"
            [size]="'lg'"
            [label]="'basket.checkout' | translate | hideTranslation"
            (onClick)="toNextStep()"
          ></ls-button>

          <ls-button
            data-nested-translation="step-navigation.tickets"
            [styleClass]="'button-secondary'"
            [color]="'secondary'"
            [size]="'lg'"
            [label]="'step-navigation.tickets' | translate | hideTranslation"
            (onClick)="toTicketSelection()"
          ></ls-button>
        </div>
      }
    </div>
  }
}

<ng-template
  #bookedTariffTypeTemplate
  let-bookedTariffType="bookedTariffType"
  let-isInPackage="isInPackage"
  let-packageProductIndex="packageProductIndex"
>
  <div
    class="basket-tariff-type p-6"
    [ngClass]="{
      'm-l-8 p-y-4': isInPackage,
      'bg-white': !isInPackage,
      'border-dashed border-none border-top-1': isInPackage && !!packageProductIndex
    }"
  >
    @if (!isInPackage) {
      <h5 class="text-base font-semibold line-height-3">{{ bookedTariffType.productTypeName | translate }}</h5>
    } @else {
      <i class="las la-undo rotate-180"></i>

      <h6 class="text-sm font-semibold inline-block m-l-4">
        {{ bookedTariffType.productTypeName | translate }}
      </h6>
    }

    <ul class="list-none flex flex-column p-0 m-l-0">
      @for (bookedTariff of bookedTariffType.tariffs; track bookedTariffIndex; let bookedTariffIndex = $index) {
        <li class="m-y-2" [ngClass]="{ 'm-l-8': isInPackage }">
          @if (!bookedTariff.amanoParkingReservations.length) {
            <div class="basket-tariff flex flex-column">
              @if (!isInPackage) {
                <h5 class="text-base font-normal m-b-4">
                  {{ bookedTariff.ticketName | translate }}
                  @if (!!bookedTariff.voucherCode) {
                    <span>({{ bookedTariff.voucherCode }})</span>
                  }
                </h5>

                <ng-container *ngTemplateOutlet="bookedTariffPromoCodeDiscount; context: { bookedTariff }" />

                <ng-container
                  *ngTemplateOutlet="bookedTariffPromoCodePriceDiscountTemplate; context: { bookedTariff, isInPackage }"
                />
              } @else {
                <ng-container *ngTemplateOutlet="bookedTariffPromoCodeDiscount; context: { bookedTariff }" />

                <div class="flex justify-content-between align-items-center">
                  <h6 class="basket-package-product-text-color text-sm font-medium">
                    {{ bookedTariff.ticketName | translate }}
                  </h6>

                  <ng-container
                    *ngTemplateOutlet="
                      bookedTariffPromoCodePriceDiscountTemplate;
                      context: { bookedTariff, isInPackage }
                    "
                  />
                </div>
              }
            </div>
          } @else {
            <ul class="list-none m-l-0">
              @for (
                amanoParkingReservation of bookedTariff.amanoParkingReservations;
                track amanoParkingReservationIndex;
                let amanoParkingReservationIndex = $index
              ) {
                <li class="m-y-2">
                  <div
                    class="flex justify-content-between align-items-center"
                    [ngClass]="{ 'basket-package-product-text-color': isInPackage }"
                  >
                    @if (!isInPackage) {
                      <h5 class="text-base font-normal">
                        {{ bookedTariff.ticketName | translate }}
                        @if (bookedTariff.voucherCode) {
                          <span>({{ bookedTariff.voucherCode }})</span>
                        }
                      </h5>

                      <span class="text-sm font-semibold">
                        {{ amanoParkingReservation.price | formatPrice: currencySettings }}
                      </span>
                    } @else {
                      <h6 class="text-sm font-medium line-height-3">
                        {{ bookedTariff.ticketName | translate }}
                      </h6>

                      <span class="text-sm font-semibold">
                        {{ amanoParkingReservation.price | formatPrice: currencySettings }}
                      </span>
                    }
                  </div>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </div>
</ng-template>

<ng-template #bookedTariffPromoCodeDiscount let-bookedTariff="bookedTariff">
  @if (!!bookedTariff?.promoCodeDiscounts && bookedTariff.price !== bookedTariff.discountedPrice) {
    <div class="basket-promo-code-discount flex flex-column">
      @for (promoCodeDiscount of bookedTariff.promoCodeDiscounts | keyvalue; track promoCodeDiscount.key) {
        <div class="flex justify-content-between">
          <span class="basket-discount-promo-code text-sm overflow-hidden white-space-nowrap text-overflow-ellipsis">
            {{ promoCodeDiscount.key }}
          </span>

          <span class="w-3rem text-right text-sm">-{{ promoCodeDiscount.value.discountPercentage }}%</span>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #bookedTariffPromoCodePriceDiscountTemplate let-bookedTariff="bookedTariff" let-isInPackage="isInPackage">
  <div class="flex justify-content-between">
    @if (!isInPackage) {
      <span class="text-sm font-normal">
        {{ bookedTariff.count }}x
        {{ bookedTariff.price | formatPrice: currencySettings }}
      </span>
    }

    @if (bookedTariff?.promoCodeDiscounts && bookedTariff.price !== bookedTariff.discountedPrice) {
      <div class="flex gap-2 align-items-baseline text-right">
        @if (isInPackage) {
          <span class="basket-package-product-text-color text-sm font-medium">{{ bookedTariff.count }}x</span>
        }

        <span class="basket-promo-code-price text-xs font-semibold line-through">
          {{ bookedTariff.price | formatPrice: currencySettings }}
        </span>

        <span class="basket-promo-code-discounted-price text-sm font-semibold">
          {{ bookedTariff.discountedPrice | formatPrice: currencySettings }}
        </span>
      </div>
    } @else {
      <div class="flex gap-2">
        @if (isInPackage) {
          <span class="basket-package-product-text-color text-sm font-medium">
            {{ bookedTariff.count }}x {{ bookedTariff.price | formatPrice: currencySettings }}
          </span>
        } @else {
          <span class="text-sm font-semibold">
            {{ bookedTariff.count * bookedTariff.price | formatPrice: currencySettings }}
          </span>
        }
      </div>
    }
  </div>
</ng-template>
